import { ContractType } from './ContractType'
import { Duration } from './Duration'
import { InsuranceAmount } from './InsuranceAmount'
import { ProfessionalRisk } from './ProfessionalRisk'
import { RisksCovered } from './RisksCovered'
import { SportRisk } from './SportRisk'
import { Territory } from './Territory'

export const MainStep = () => {
  return (
    <>
      <InsuranceAmount />
      <RisksCovered />
      <ContractType />
      <Duration />
      <Territory />
      <SportRisk />
      <ProfessionalRisk />
    </>
  )
}
